export default __webpack_public_path__ + "static/media/magnifying.glass@2x.5b947a5b.png";